var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Center, Text } from "@chakra-ui/react";
export function Warning(_a) {
    var text = _a.text;
    return (_jsx(Center, { children: _jsx(Text, __assign({ as: "h3", variant: "searchResultsWarning" }, { children: text })) }));
}
